<template>
  <div>
    <div class="flex items-center px-8 sm:px-4 py-3 shadow-md bg-white ">
      <div class="flex-grow-0"><h1 class="text-xl m-0 sm:text-xl sm:mr-2">Reports</h1></div>
      <div class="flex-grow text-right">
        <div v-if="isSearchBox" class="search mr-6 sm:mr-2">
          <input class="input-sm"
                 type="text"
                 :value="value"
                 v-on:input="$emit('input', $event.target.value)"
                 placeholder="Search by name...">
        </div>
      </div>
      <div class="flex-grow-0">

        <el-dropdown trigger="click" @command="handleCommand">
          <el-button type="primary" size="medium">
            <font-awesome-icon class="mr-2 sm:mr-0" :icon="['far', 'download']"/> <span class="sm:hidden">Download Report</span>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="download-pdf">Download PDF</el-dropdown-item>
            <el-dropdown-item command="download-csv">Download CSV/Excel</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </div>


    <slot name="filter"></slot>

    <div class="text-right px-8 sm:px-4 pt-3" v-if="showDatePiker">

      <el-date-picker
          v-model="dateRange"
          type="daterange"
          align="right"
          unlink-panels
          v-on:change="onSelectDate"
          :clearable="false"
          :default-time="['12:00:00', '12:00:00']"
          range-separator="-"
          start-placeholder="Start date"
          end-placeholder="End date"
          :picker-options="pickerOptions"
          format="M/d/yyyy">
      </el-date-picker>

    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
  import reportsMenuMixin from './reports-menu-mixin';

  const moment = require('moment');

  export default {
    name: 'ReportsMenu',
    props: {
      startDate: String,
      endDate: String,
      firstDonationDate: [String, Boolean],
      showDatePiker: {
        type: Boolean,
        'default': true,
      },
      isSearchBox: {
        type: Boolean,
        'default': false,
      },
      value: null
    },
    mixins: [reportsMenuMixin],
    created() {
      const defDate = this.dates.find(d => d.active);

      if(this.startDate && this.endDate){
        this.dateRange = [this.startDate, this.endDate];
      }
      else if (defDate) {
        this.dateRange = [defDate.start, defDate.end];
      }

      this.updateShortcuts();
      this.addAllTime();
    },
    methods: {
      handleCommand(command) {
      switch (command){
          case 'download-pdf':
            this.$emit('download', 'pdf');
            break
          case 'download-csv':
            this.$emit('download', 'csv');
            break
        }
      },
      updateShortcuts(){
        this.pickerOptions.shortcuts = this.dates.map(dt => (
            {
              text: dt.title,
              onClick(picker) {
                picker.$emit('pick', [dt.start, dt.end]);
              }
            }
        ));
      },
      onSelectDate(dtr){
        this.$emit('update-date', dtr[0], dtr[1]);
      },
      addAllTime() {
        if (this.firstDonationDate) {

          this.dates = this.dates.filter(dt => {
            return dt.title !== 'All Time';
          });

          this.dates.push({
            title: 'All Time',
            start: this.firstDonationDate,
            end: moment().format('MM/DD/YYYY'),
          });

          this.updateShortcuts();
        }
      }
    },
    watch: {
      'firstDonationDate'() {
        this.addAllTime();
      },
    },
    data() {
      return {
        isPickerVisible: false,
        dp: null,
        dateRange: null,
        pickerOptions: {
          shortcuts: [
              {
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }
          ]
        },
      };
    },
  };
</script>
